// ТЗ 0088 — раздел «Маркетинг». Все имена с префиксом `marketing` /
// `MARKETING_` / `IMarketing`: барабан `core/hooks` собирает модули через
// `export *`, и одноимённое (`DRILLDOWN_NEXT` опросов) столкнулось бы.
export * from './types';
export * from './seoTypes';
export * from './marketingModel';
export * from './marketingSearchModel';
export * from './marketingIntelModel';
export * from './marketingInspectorModel';
export * from './marketingMatrixModel';
export * from './marketingOfflineModel';
export * from './marketingCompareModel';
export * from './marketingLegacyLinks';
export * from './marketingQuickFilters';
export * from './marketingTodayModel';
export * from './marketingSeoModel';
export * from './marketingJourneyModel';
export * from './marketingAdsModel';
export * from './marketingLeadsModel';
export * from './marketingInsightsModel';
export * from './marketingCoursesModel';
export * from './marketingPalette';
export * from './marketingApi';
export * from './useMarketingPermissions';
export * from './useMarketingDeepLink';
export * from './useMarketingReports';
export * from './useMarketingSeo';
export * from './useMarketingInspector';
export * from './useMarketingMutations';
export * from './useMarketingRecalcWatch';
export * from './useMarketingCompare';
export * from './marketingCohortsModel';
